export const getConstHeadersMiddleware = (headers: Record<string, string>) => ({
    'Accept-Language': 'pl-PL',
    ...headers,
});
